module.exports = __webpack_public_path__ + "img/w10.a85ed713.svg";